import React from "react"

export default function StripePaymentMethod(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { method, isSelected, onSelect, onDelete, canBeDeleted } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleSelect() {
    onSelect(method)
  }
  function handleDelete(event) {
    event.stopPropagation()
    onDelete(method)
  }

  function renderCardBrandIcon(brand) {
    let iconName

    switch (brand) {
      case "americanexpress":
        iconName = "amex"
        break
      case "visa":
        iconName = "visa"
        break
      case "mastercard":
        iconName = "mastercard"
        break
      default:
        iconName = "credit-card"
        break
    }

    return (
      <i
        className={`fab fa-2x fa-cc-${iconName}`}
      />
    )
  }

  function renderRemoveCardLink() {
    if (canBeDeleted) {
      return (
        <a
          onClick={(event) => {
            handleDelete(event)
          }}
        >
          <i className="fal fa-trash-alt fr-p1" />
        </a>
      )
    } else {
      return <span />
    }
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const { card, metadata } = method
  const { brand, last4 } = card
  const label = metadata && metadata["label"]

  // -------------------------------------

  return (
    <div
      className={isSelected ? "item default" : "item"}
      onClick={() => handleSelect()}
    >
      <div className="row" style={{ display: "flex", alignItems: "center" }}>
        <div className="col-xs-1">
          <input type="radio" checked={isSelected} readOnly={true} />
        </div>
        <div className="col-xs-2 col-md-1">{renderCardBrandIcon(brand)}</div>
        <div className="col-xs-7 col-md-8">
          {label && <div className="card--label">{label}</div>}
          <div className="fr-p2 fr-light">**** **** **** {last4}</div>
        </div>
        <div className="col-xs-1">{renderRemoveCardLink()}</div>
      </div>
    </div>
  )
}
